import { ModulePlaceholder } from "@/components/modules/ModulePlaceholder";

const Motion = () => {
  return <ModulePlaceholder moduleKey="motion" />;
};

export default Motion;
